// extracted by css-extract-rspack-plugin
export default {"dropdown":"HoverCard-module__dropdown___fyJn4"};